import {Injectable} from "@angular/core";
import {AuthService} from "../../libraries/service/auth/auth.service";
import {Observable} from "rxjs";
import {HttpHeaders} from "@angular/common/http";
import {map} from "rxjs/operators";
import {Yii} from "../../libraries/interfaces/Yii";
import {IWenji} from "../../libraries/interfaces/IWenji";

declare const wenji: IWenji;

@Injectable()
export class AuthWatabilightService extends AuthService {
    // Set url to avoid default redirection
    public url: string = 'watabilight/booking';

    public watabiLogin(): void {
        const url: string = `${sessionStorage.getItem("$instance_url")}wui_watabi/login`;
        const data = {
            "username": wenji.watabilight.user.uid,
            "password": wenji.watabilight.user.pwd,
            "companyId": "",
            "getToken": "1"
        };
        const dataUrl = new URLSearchParams(data).toString();
        const headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
        };
        this.http.post(url, dataUrl, {headers})
            .subscribe(
                (res: { error: boolean, xtoken: string }) => {
                    if (!res.error) {
                        sessionStorage.setItem('_tmp_xtoken', res.xtoken);
                    }
                },
                (error: any): any => {
                    console.error(error);
                }
            );


    }

    public getXsecurity(): Observable<any> | string {
        const json = {
            "ip": sessionStorage.getItem('$ip'),
            "uid": wenji.watabilight.user.uid,
            "pwd": wenji.watabilight.user.pwd
        };
        const body = JSON.stringify(json);
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers };
        this.http
            .post(this.xsecurityPath, body, options)
            .subscribe(
                (res: any) => {
                    this.getToken(res);
                },
                (error: any): any => {
                    return error;
                    // this.handleError(error);
                }
            );
        return '';
    }

}